import styled from 'styled-components';
import Box from "@mui/material/Box";
import withColors from '../../../../styles/withColors';
import { MediaQuerys } from '../../../../styles/GlobalStyle';
import { useColors } from "../../../../Context/ColorsContext"
import { Card, TextField } from '@mui/material';

const { mobile, tablet, desktop } = MediaQuerys;

// const tabletStartWidth = 768;
// const mobile = `@media (max-width: ${tabletStartWidth}px)`;

const ContainerStyle = styled.div`
  width:100%;
  height:100%;
  display:flex;
  justify-content:center;
  align-items:center;
  padding-bottom:5em;
  /*
  background: ${({ colors }) => colors.red};
  */
  ${mobile} {
    flex-direction:column;
    height:max-content;
    padding:1em;
  }
`

const FormStyle = styled.div`
  display:flex;
  flex-direction:column;
  align-items:center;
  ${mobile} {
    width:100%;
    padding:0 1em;
  } 
`

const TitleStyle = styled.p`
  font-size:2.2rem;
  font-weight: bold;
  text-align:center;
  color:${({ colors }) => colors.blackFont};
  ${mobile} {
    font-size:1.8rem;
  }
`

// padding:.2em 0 .7em;
const SectionRowStyle = styled.section`
  display:flex;
  width:100%;
  align-items:center;
  padding: .2em 0;
  text-align:left;
  justify-content:center;
  ${mobile} {
    flex-direction:column;
    align-items: center;
  }
`

// margin-left: ${props => (props.second ? '2em' : '')};
const SectionInputStyle = styled.section`
  display:flex;
  flex-direction:column;
  min-width:280px;
  width: 100%;
  max-width: 300px;
  ${mobile} {
    width:100%;
    margin-top: ${props => (props.bottom ? '1em' : '')};
    margin-left:0;
  }
`

const LabelStyle = styled.label`
  padding-bottom:.3em;
  padding-left:.3em;
  color:${({ colors }) => colors.blackFont};
  ${tablet} {
    font-size: '0.75rem !important';
  }
`

const ContainerInputStyle = styled.div`
  background: ${({ colors }) => colors.gray};
  border-bottom:2px solid ${({ colors }) => colors.gray};
  height:2em;
  padding:0 .5em;
  display:flex;
  align-items:center;
  border-radius:5px;
`

const FigureStyle = styled.figure`
  display:flex;
  justify-content:center;
  margin-left: ${props => (props.marginLeft ? ".5em" : "")};
  margin-top: ${props => (props.marginTop ? ".3em" : "")};
  margin-bottom: ${props => (props.marginBottom ? ".3em" : "")};
  margin-right: ${props => (props.marginRight ? "1em" : "")};
`

const InputStyle = styled.input`
  background: ${({ colors }) => colors.gray};
  width:100%;
  color:${({ colors }) => colors.blackFont};
  &::-webkit-inner-spin-button, ::-webkit-outer-spin-button  {
    -webkit-appearance: none; 
    margin: 0; 
  }
  -moz-appearance:textfield;
`

export const InputFilter = styled('input')(() => {
  const { colors } = useColors();
  return {
    background: colors.gray,
    color: colors.blackFont,
    width: '100%',
    padding:'.2em 1em',
    borderRadius:'5px',
    color:'gray',
    [mobile]: {
      padding:'.5em 1em',
      fontSize:'1.2em',
    }
  }
})

export const CustomInput = styled(TextField)(() => {
  const { colors } = useColors();
  return {
    width: '100%',
    marginTop: '.5rem',
  
    '.MuiInputBase-root': {
      height: 44,
      background: colors.white,
      borderRadius: 6,
      fontSize: 15,
    },
  }
});

const SpanStyle = styled.span`
  width: 100%;
  text-align: center;
  color: ${({ colors }) => colors.red};
  padding-top:.3em;
  padding-left:.3em;
  height:1.5em;
  font-size: 1rem;
  &.activate {
    visibility:visible;
    transition:all .3s ease;
  }
  &.closed {
    visibility:hidden;
    transition:all .3s ease-in-out;
  }
`

const SpanLinkStyle = styled.p`
  width: 100%;
  text-align: right;
  color: ${({ colors }) => colors.buttonActionColor};
  margin: 0;
  padding-top: .3rem;
  height:1.5em;
  font-size: 0.75rem;
  &.activate {
    visibility:visible;
    transition:all .3s ease;
  }
  &.closed {
    visibility:hidden;
    transition:all .3s ease-in-out;
  }
`

const SectionBtnStyle = styled.section`
  text-align: center;
  padding:1em 0 2em;
  width:100%;
  display: ${props => (props.double ? 'block' : 'flex')};
  justify-content: center;
  ${mobile} {
    padding:1.5em 0 2em;
  }
`

const BtnSubmitStyle = ({ colors, disabled, ...props }) => (
  <button
    {...props}
    style={{
      color: colors.white,
      background: disabled ? colors.gray : colors.buttonActionColor,
      cursor: disabled ? 'not-allowed' : 'pointer',
      padding: '.5em 2em',
      borderRadius: '5px',
      display: 'inline-block',
      justifyContent: 'center',
      transition: 'all .3s ease-in-out',
      width: '50%',
      '&:hover': {
        transition: 'all .3s ease',
        opacity: '.8',
      },
      '&:active': {
        transition: 'all .3s ease',
        opacity: '1',
      },
    }}
  />
);

const BoxModalStyle = styled(Box)(() => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
}))

const CustomLabel = styled('label')(() => {
  const { colors } = useColors();
  return {
    paddingBottom: '.3rem',
    // paddingLeft: '.3rem',
    color: colors.grayFont,
    [desktop]: {
      fontSize: '1.1rem',
    }
  }
})

export const Subtitle = styled('span')(() => {
  const { colors } = useColors();
  return {
      color: colors.blackFont,
      fontSize: '1.6rem',
      // paddingLeft: '1rem',
      fontWeight: 'bold',
      // paddingBottom: '2em',
      [mobile]: {
        paddingLeft: '0',
        paddingBottom: '2.5em',
      }
  }
})

export const ContainerLogin = styled(Card)(() => {
  const { colors } = useColors();
  return {
    border: `1px solid ${colors.gray}`, 
    borderRadius: '18px', 
    padding: '22px 20px', 
    margin: '25px',
    boxShadow: 'none',
    minWidth: '280px',

    [mobile]: {
      width: '100%',
    }
  }
})

export const Container = withColors(ContainerStyle);
export const Form = withColors(FormStyle);
export const Title = withColors(TitleStyle);
export const SectionRow = withColors(SectionRowStyle);
export const SectionInput = withColors(SectionInputStyle);
export const Label = withColors(LabelStyle);
export const ContainerInput = withColors(ContainerInputStyle);
export const Figure = withColors(FigureStyle);
export const Input = withColors(InputStyle);
export const Span = withColors(SpanStyle);
export const SpanLink = withColors(SpanLinkStyle);
export const SectionBtn = withColors(SectionBtnStyle);
export const BtnSubmit = withColors(BtnSubmitStyle);
export const BoxModal = withColors(BoxModalStyle);
export const LabelCustom = withColors(CustomLabel);
export const SubtitleCustom = withColors(Subtitle);